import { isSameDay } from 'date-fns';
import { DateHeaderProps } from 'react-big-calendar';

export const MonthDateHeader: React.ComponentType<DateHeaderProps> = ({
  label,
  isOffRange,
  onDrillDown,
  date,
}) => (
  <button
    onClick={onDrillDown}
    className={`${
      isSameDay(new Date(), date)
        ? ' bg-primary-600 hover:bg-primary-500 font-semibold  text-white'
        : 'hover:bg-gray-200'
    } transition flex h-6 w-6 items-center justify-center rounded-full  `}
  >
    {label}
  </button>
);
